import {Matcher} from '@/lib/axiosAddTransforms'
import {pageResponse} from '@/transformers/utils'

function noDash(text: string): string {
  return text.replace(/-/g, '')
}

const matchers: Matcher[] = [
  {
    test: /^\/get-companies\/?/,
    method: 'get',
    transform: {
      request: (payload) => {
        payload.url = 'bizs/search_company/'
        return payload
      },
      response: (data) => {
        if(!data || !data.companies) {
          return data
        }
        data.companies = data.companies.map((company) => companyResponse(company))
        return {
          companies: data.companies,
          ...propertyResponse(data),
        }
      },
    },
  },
]

export default matchers

const companyResponse = (data) => {
  const {
    bizName,
    reprName,
    bizTel,
  } = data
  return {
    ...data,
    name: bizName,
    ownerName: reprName,
    bizPhoneNumber: noDash(bizTel),
  }
}

const propertyResponse = (data) => {
  const {next, previous, totalCount} = data
  return {
    nextPage: pageResponse(next),
    prevPage: pageResponse(previous),
    totalCount,
  }
}
